<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="deliveryRecordTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="videoImgUrl" slot-scope="data">
          <img class="table-img" :src="data.row.videoImgUrl">
        </template>
        <template slot="status" slot-scope="data">
          <el-tag type="success" v-if="data.row.status === 10">清运完成</el-tag>
          <el-tag type="danger" v-else-if="data.row.status === 5">清运中</el-tag>
          <el-tag type="success" v-else-if="data.row.status === 8">等待清运</el-tag>
          <el-tag type="danger" v-else>系统核查中</el-tag>
        </template>
        <template slot="tableTopCustom" v-if="this.$route.query.userid !== undefined">
          <div class="table-list-desc">该用户共投递{{form.formResult.total}} 次 </div>
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <el-dialog title="视频" :visible.sync="openVideo" width="80%" append-to-body @close="handleClose">
      <video ref="videoPlayer" :src="this.videoPath" v-if="this.videoPath != null && openVideo" controls></video>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'DeliveryRecordList',
  isAutoComponent: true,
  mounted() {
    this.setSnFromRoute()
  },
  watch: {
    '$route.query.sn': function(newVal) {
      if (newVal) {
        this.setSnFromRoute()
      }
    },
    '$route.query.userid': function(newVal) {
      if (newVal) {
        this.setSnFromRoute()
      }
    }
  },
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      openVideo: false,
      videoPath: null,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_DELIVERY_RECORD_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablUserDeliveryRecords/dataList' }
        },
        formInputsData: [
          { name: '箱体名称', key: 'boxName', value: '', type: 'text', hidden: false },
          { name: 'SN', key: 'sn', value: this.$route.query.sn || '', type: 'text', hidden: false },
          { name: 'userid', key: 'userId', value: this.$route.query.userid || '', type: 'text', hidden: false },
          { name: '状态',
            key: 'status',
            hidden: false,
            value: '',
            type: 'select',
            data: [
              { label: '已发放', value: '10' },
              { label: '清运中', value: '5' },
              { label: '未处理', value: '7' }
            ] }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          url: window.wtConst.BASE_API + '/modules/ablUserDeliveryRecords/exportExcel',
          fileName: '投递记录',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '箱体名称', key: 'boxName', type: 'text' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: 'userid', key: 'userId', type: 'text' },
          { name: '投递重量(Kg)', key: 'weight', type: 'text' },
          { name: '单价(元)', key: 'unitPrice', type: 'text' },
          { name: '投递金额(元)', key: 'userReceivedAmount', type: 'text' },
          { name: '状态', key: 'status', type: 'custom' },
          { name: '镜头1', key: 'videoImgUrl', type: 'custom' },
          { name: '镜头2', key: '', type: 'custom' },
          { name: '原因', key: '', type: 'text' },
          { name: '开始时间', key: 'startTime', type: 'text' },
          { name: '结束时间', key: 'endTime', type: 'text' }],
        formTableButtonsData: [
          { name: '视频', key: 'VIDEO', action: 'VIDEO', className: 'primary', hidden: (row) => this.$route.query.userid === undefined },
          { name: '清运记录', key: 'TRANSPORTATION', action: 'TRANSPORTATION', permission: 'TRANSPORTATION', className: 'primary', hidden: (row) => row.id === '12' }
        ],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: false, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'TRANSPORTATION') {
          // 通过路由跳转到清运记录页面，并传递id作为参数
          this.$router.push({
            name: 'transportationList',
            query: { userid: data.row.userId }
          })
        } else if (data.item.action === 'VIDEO') {
          this.videoPath = data.row.videoUrl
          this.openVideo = true
        }
      }
    },
    setSnFromRoute() {
      const userid = this.$route.query.userid
      const sn = this.$route.query.sn
      if (userid) {
        // 更新userid值
        this.form.formInputsData.forEach((item, index) => {
          if (item.key !== 'boxName') {
            item.hidden = true
          }
          if (item.key === 'userid') {
            this.$set(this.form.formInputsData[index], 'value', userid)
          }
        })
        // 触发查询
        setTimeout(() => {
          this.$refs.deliveryRecordTableRef && this.$refs.deliveryRecordTableRef.doQuery()
        }, 200)
      }
      if (sn) {
        // 更新userid值
        this.form.formInputsData.forEach((item, index) => {
          if (item.key === 'sn') {
            this.$set(this.form.formInputsData[index], 'value', sn)
          }
        })
        // 触发查询
        setTimeout(() => {
          this.$refs.deliveryRecordTableRef && this.$refs.deliveryRecordTableRef.doQuery()
        }, 200)
      }
    },
    handleClose() {
      this.$refs.videoPlayer.pause() // 停止视频播放
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
